import { CoreMenu } from '@core/types'
import { RolesEnum } from '../modules/general/users/core/enums/roles.enum'
import { FunctionalType } from '../shared/types/functional.type'
import { checkVisibleFunctional } from '../shared/utils/check-visible-functional'

export function getMenu(role: RolesEnum): CoreMenu[] {
    const isHidden = (functional: FunctionalType): boolean => !checkVisibleFunctional(functional, role)

    return [
        {
            id: 'moderation-kyc',
            title: '',
            type: 'section',
            hidden: isHidden('errors-list') && isHidden('bids-list'),
            children: [
                {
                    id: 'error',
                    title: 'Alpaca',
                    type: 'item',
                    icon: 'alert-triangle',
                    url: '/moderation-kyc/errors',
                    hidden: isHidden('errors-list'),
                },
                {
                    id: 'bids',
                    title: 'Модерация',
                    type: 'item',
                    icon: 'thumbs-up',
                    url: '/moderation-kyc/bids',
                    hidden: isHidden('bids-list'),
                }
            ]
        },
        {
            id: 'general',
            title: 'Общее',
            type: 'section',
            children: [
                {
                    id: 'users',
                    title: 'Пользователи',
                    type: 'collapsible',
                    icon: 'users',
                    hidden: isHidden('users-list') && isHidden('users-manual-aml-check-list'),
                    children: [
                        {
                            id: 'all-users',
                            title: 'Все пользователи',
                            type: 'item',
                            url: '/general/users/list',
                            hidden: isHidden('users-list'),
                        },
                        {
                            id: 'manual-aml-check',
                            title: 'Ручная AML-проверка',
                            type: 'item',
                            url: '/general/users/manual-aml-check',
                            hidden: isHidden('users-manual-aml-check-list'),
                        },
                    ]
                },

                {
                    id: 'strategies',
                    title: 'Стратегии',
                    type: 'item',
                    icon: 'bar-chart-2',
                    url: '/general/strategies',
                    hidden: isHidden('strategies-list'),
                },
                {
                    id: 'requests',
                    title: 'Заявки',
                    type: 'item',
                    icon: 'mail',
                    url: '/general/requests',
                    hidden: isHidden('requests-list'),
                },
                {
                    id: 'transactions',
                    title: 'Транзакции',
                    type: 'item',
                    icon: 'repeat',
                    url: '/general/transactions',
                    hidden: isHidden('transactions'),
                },
                {
                    id: 'commissions',
                    title: 'Комиссии',
                    type: 'item',
                    icon: 'dollar-sign',
                    url: '/general/commissions',
                    hidden: isHidden('commissions'),
                },
                {
                    id: 'client-trade',
                    title: 'Client Trade',
                    type: 'collapsible',
                    icon: 'git-pull-request',
                    hidden: isHidden('client-trade-trading') && isHidden('client-trade-groups'),
                    children: [
                        {
                            id: 'client-trade-trading',
                            title: 'Торговля',
                            type: 'item',
                            url: '/general/client-trade/trading',
                            hidden: isHidden('client-trade-trading'),
                        },
                        {
                            id: 'client-trade-groups',
                            title: 'Группы',
                            type: 'item',
                            url: '/general/client-trade/groups',
                            hidden: isHidden('client-trade-groups'),
                        },
                    ]
                },
                {
                    id: 'emergency-messages',
                    title: 'Экстренные сообщения',
                    type: 'item',
                    icon: 'alert-octagon',
                    url: '/general/emergency-messages',
                    hidden: isHidden('emergency-messages'),
                },
                {
                    id: 'signals',
                    title: 'Сигналы',
                    type: 'collapsible',
                    icon: 'trending-up',
                    hidden: isHidden('signals'),
                    children: [
                        {
                            id: 'signals-create',
                            title: 'Создать сигнал',
                            type: 'item',
                            url: '/general/signals/create',
                            hidden: isHidden('signals'),
                        },
                        {
                            id: 'signals-recipients',
                            title: 'Получатели',
                            type: 'item',
                            url: '/general/signals/recipients',
                            hidden: isHidden('signals'),
                        }
                    ]
                },
                {
                    id: 'tariffs',
                    title: 'Тарифы',
                    type: 'collapsible',
                    icon: 'credit-card',
                    hidden: isHidden('tariffs-list') && isHidden('tariffs-groups') && isHidden('feature-sets'),
                    children: [
                        {
                            id: 'tariff-list',
                            title: 'Список тарифов',
                            type: 'item',
                            url: '/tariffs/tariff-list',
                            hidden: isHidden('tariffs-list'),
                        },
                        {
                            id: 'tariff-group',
                            title: 'Группы тарифов',
                            type: 'item',
                            url: '/tariffs/tariff-group',
                            hidden: isHidden('tariffs-groups'),
                        },
                        {
                            id: 'feature-sets',
                            title: 'Наборы функций',
                            type: 'item',
                            url: '/tariffs/feature-sets',
                            hidden: isHidden('feature-sets'),
                        }
                    ]
                },
                {
                    id: 'reports',
                    title: 'Отчеты',
                    type: 'item',
                    icon: 'book',
                    url: '/other/reports',
                    hidden: true,
                },
                {
                    id: 'analytics',
                    title: 'Аналитика',
                    type: 'item',
                    icon: 'bar-chart-2',
                    url: '/other/analytics',
                    hidden: isHidden('analytics'),
                },
                {
                    id: 'bids-kyc',
                    title: 'Заявки KYC (old)',
                    type: 'item',
                    icon: 'alert-triangle',
                    url: '/general/bids-kyc',
                    disabled: true,
                },
            ]
        },

        {
            id: 'other',
            title: 'Контент',
            type: 'section',
            hidden: isHidden('collections-list'),
            children: [
                {
                    id: 'collections',
                    title: 'Список подборок',
                    type: 'item',
                    icon: 'list',
                    url: '/general/collections',
                    hidden: isHidden('collections-list'),
                },
            ]
        },
        {
            id: 'settings',
            title: 'Настройки',
            type: 'section',
            hidden: isHidden('permissions-list') && isHidden('mobile-versions') && isHidden('duty-manager'),
            children: [
                {
                    id: 'permissions',
                    title: 'Разрешения',
                    type: 'item',
                    icon: 'lock',
                    url: '/settings/permissions',
                    hidden: isHidden('permissions-list'),
                },
                {
                    id: 'systemic',
                    title: 'Системные',
                    type: 'collapsible',
                    icon: 'settings',
                    hidden: isHidden('mobile-versions') && isHidden('duty-manager'),
                    children: [
                        {
                            id: 'mobile-versions',
                            title: 'Версии',
                            type: 'item',
                            url: '/settings/systemic/mobile-versions',
                            hidden: isHidden('mobile-versions'),
                        },
                        {
                            id: 'duty-manager',
                            title: 'Дежурный менеджер',
                            type: 'item',
                            url: '/settings/systemic/duty-manager',
                            hidden: isHidden('duty-manager'),
                        }
                    ]
                }
            ]
        },
    ]
}
